var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`background-image:url(${_vm.url});background-size:${_vm.size};margin-top:${_vm.marginTop};`)},[_c('el-row',{style:(`width:${_vm.width};height:${_vm.height}`),attrs:{"gutter":_vm.gutter,"type":_vm.type,"justify":_vm.justify,"align":_vm.align}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }